/** @jsx jsx */
import { jsx } from 'theme-ui'

import { Space } from './Space'

const Padding = props => <Space {...props} property="padding" />

export default Padding
